import { CartGroupedSections, CartUpdateEvent } from "@theme/events";
import { morphSection } from "@theme/section-renderer";
import { fetchConfig } from "@theme/utilities";

/**
 * Botão "Adicionar" do kit de limpeza no cart drawer.
 * Adiciona a variante configurada ao carrinho e atualiza o drawer.
 */
class CartKitAddon extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.#onClick);
  }

  #onClick = (event) => {
    const target = event.target;
    const button = target instanceof Element ? target.closest("[data-kit-add]") : null;
    if (!button || button.disabled) return;
    this.#addToCart(button);
  };

  async #addToCart(button) {
    const sectionId = this.dataset.sectionId;
    const variantId = Number(this.dataset.variantId);
    if (!sectionId || !variantId) return;

    const errorEl = this.querySelector("[data-kit-error]");
    errorEl?.classList.add("hidden");
    button.disabled = true;
    button.classList.add("btn--loading");

    try {
      const sections = [];
      document.dispatchEvent(new CartGroupedSections(sections));
      const sectionIds = [...new Set([...sections, sectionId])];

      const body = JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(","),
        sections_url: window.location.pathname,
      });

      const response = await fetch(FoxTheme.routes.cart_add_url, fetchConfig("json", { body }));
      const parsed = await response.json();
      const html = parsed?.sections?.[sectionId];

      if (!response.ok || parsed.status || !html) {
        throw new Error(parsed?.description || parsed?.message || "Add to cart failed");
      }

      const doc = new DOMParser().parseFromString(html, "text/html");
      const countText = doc.querySelector('[ref="cartItemCount"]')?.textContent;
      const itemCount = countText ? parseInt(countText, 10) || 0 : 0;
      const resource = Array.isArray(parsed.items) ? parsed : {};

      // Dispatch from the cart-items component so it does not re-handle its own event.
      const cartItems = this.closest("cart-items-component") || this;
      cartItems.dispatchEvent(
        new CartUpdateEvent(resource, sectionId, {
          itemCount,
          source: "cart-items-component",
          sections: parsed.sections,
        })
      );

      await morphSection(sectionId, html);
    } catch (error) {
      console.error(error);
      if (errorEl) {
        errorEl.textContent = this.dataset.errorText || "";
        errorEl.classList.remove("hidden");
      }
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.classList.remove("btn--loading");
      }
    }
  }
}

if (!customElements.get("cart-kit-addon")) {
  customElements.define("cart-kit-addon", CartKitAddon);
}
